module.exports = __webpack_public_path__ + "static/media/heart.f2610513.svg";